module.exports = __webpack_public_path__ + "static/media/victory_big.334383be.png";